import React from "react";
import { motion } from "framer-motion";

function CircularProgress({ value, label = false, size = 40, strokeWidth = 5, ...props }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = ((value > 100 ? 100 : value) / 100) * circumference;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        ...props.style
      }}
    >
      <svg width={size} height={size}>
        {/* Background Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e6e6e6"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* Progress Circle */}
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#2AD29D"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: circumference - progress }}
          transition={{ duration: 0.5 }}
          style={{
            transform: "rotate(-90deg)",
            transformOrigin: "center"
          }}
        />
      </svg>
      {/* Label */}
      {label && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold"
          }}
        >
          {`${Math.round(value)}%`}
        </div>
      )}
    </div>
  );
}

export { CircularProgress };
